(() => {
  if (window.sicilusB2BPilotReady) return;
  window.sicilusB2BPilotReady = true;
  const targets = () => new Map([...document.querySelectorAll('[data-sbp-section]')].map(el => [el.dataset.sbpSection, el]));
  function sync() {
    const sections = targets();
    const config = document.querySelector('[data-sbp-config]');
    const fallback = config?.dataset.sbpFallback || '';
    document.querySelectorAll('[data-sbp-route]').forEach(link => {
      const key = link.dataset.sbpRoute;
      const section = sections.get(key);
      const destination = section ? '#' + section.id : ['request', 'business', 'offers'].includes(key) ? fallback : '';
      link.hidden = !destination;
      if (destination) link.setAttribute('href', destination);
      else link.removeAttribute('href');
    });
    document.querySelectorAll('[data-sbp-route-warning]').forEach(el => { el.hidden = sections.has('request') || !!fallback; });
    const values = [...document.querySelectorAll('[data-sbp-offer-option]')].map(el => el.dataset.sbpOfferOption);
    document.querySelectorAll('[data-sbp-offer-input]').forEach(select => {
      const selected = select.value;
      [...select.options].slice(2).forEach(option => option.remove());
      values.forEach(value => select.add(new Option(value, value)));
      select.value = [...select.options].some(option => option.value === selected) ? selected : '';
    });
  }
  document.addEventListener('click', event => {
    const offer = event.target.closest('[data-sbp-offer]');
    if (offer && offer.getAttribute('href')?.startsWith('#')) {
      const target = document.getElementById(offer.hash.slice(1));
      const input = target?.querySelector('[data-sbp-offer-input]');
      if (input) {
        input.value = offer.dataset.sbpOfferName + ' · ' + offer.dataset.sbpOffer;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const validate = event.target.closest('[data-sbp-validate]');
    if (validate) {
      const valid = validate.form.reportValidity();
      const message = validate.form.querySelector('[data-sbp-validation]');
      if (message) message.hidden = !valid;
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.querySelector('[data-sbp-validate]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.target.reportValidity();
    }
  }, true);
  ['input', 'change'].forEach(type => document.addEventListener(type, event => {
    const message = event.target.closest('[data-sbp-request]')?.querySelector('[data-sbp-validation]');
    if (message) message.hidden = true;
  }));
  let pending;
  const schedule = () => { clearTimeout(pending); pending = setTimeout(sync, 0); };
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(type => document.addEventListener(type, schedule));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
  else sync();
})();
